// "Copiar datos del Aviso": filing with the UIF is deliberately manual (there
// is no public API for the SAT/UIF portal), so the app prepares the data as
// text that the compliance officer copies into the portal.
import { formatDate, formatMonth } from "./dates";
import { CLIENT_TYPE_LABELS, NOTICE_KIND_LABELS, PAYMENT_METHOD_LABELS } from "./labels";
import { formatMoney } from "./money";
import type { NoticeObligation } from "./notices";
import type { Client, Company, Operation } from "./types";

/** Notice data in Spanish (user-facing), ready to paste. */
export function noticeText(input: {
  notice: NoticeObligation;
  client: Client;
  company: Pick<Company, "legalName" | "rfc">;
  operations: readonly Operation[];
}): string {
  const { notice, client, company } = input;
  const covered = input.operations
    .filter((op) => notice.operationIds.includes(op.id))
    .sort((a, b) => a.date.localeCompare(b.date));
  const isPerson = client.type === "individual" || client.type === "foreign_individual";
  const or = (v: string | null) => v ?? "—";

  return [
    "DATOS PARA EL AVISO ANTE LA UIF",
    "Actividad vulnerable: comercialización de metales preciosos, piedras preciosas, joyas y relojes (art. 17, fr. VI LFPIORPI)",
    "",
    `Sujeto obligado: ${company.legalName}`,
    `RFC del sujeto obligado: ${or(company.rfc)}`,
    `Mes que se reporta: ${formatMonth(notice.month)}`,
    `Tipo de aviso: ${NOTICE_KIND_LABELS[notice.kind]}`,
    `Fecha límite de presentación: ${formatDate(notice.deadline)}`,
    "",
    "CLIENTE",
    `Tipo de persona: ${CLIENT_TYPE_LABELS[client.type]}`,
    `Nombre o razón social: ${client.name}`,
    `RFC: ${or(client.rfc)}`,
    ...(isPerson ? [`CURP: ${or(client.curp)}`] : []),
    isPerson
      ? `Fecha de nacimiento: ${client.birthDate ? formatDate(client.birthDate) : "—"}`
      : `Fecha de constitución: ${client.incorporationDate ? formatDate(client.incorporationDate) : "—"}`,
    `País de nacionalidad o residencia: ${or(client.country)}`,
    `Domicilio: ${or(client.address)}`,
    `Teléfono: ${or(client.phone)}`,
    ...(isPerson ? [] : [`Representante legal: ${or(client.legalRepresentative)}`]),
    ...(client.beneficialOwner ? [`Beneficiario Controlador: ${client.beneficialOwner}`] : []),
    "",
    covered.length === 1 ? "OPERACIÓN" : `OPERACIONES (${covered.length})`,
    ...covered.map(
      (op, i) =>
        `${i + 1}. ${formatDate(op.date)} · ${formatMoney(op.amount)} sin IVA · ${PAYMENT_METHOD_LABELS[op.paymentMethod]}${op.description ? ` · ${op.description}` : ""}`,
    ),
    "",
    `Monto total (sin IVA, MXN): ${formatMoney(notice.amount)}`,
  ].join("\n");
}
